"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./AdAccountsApi"), exports);
__exportStar(require("./AdCategoriesApi"), exports);
__exportStar(require("./AdSetsApi"), exports);
__exportStar(require("./AdsApi"), exports);
__exportStar(require("./AssetsApi"), exports);
__exportStar(require("./AudiencesApi"), exports);
__exportStar(require("./BillingApi"), exports);
__exportStar(require("./BusinessesApi"), exports);
__exportStar(require("./CampaignsApi"), exports);
__exportStar(require("./CapiMeasurementApi"), exports);
__exportStar(require("./ClientAccountsApi"), exports);
__exportStar(require("./CsAssetsApi"), exports);
__exportStar(require("./CsCreativesApi"), exports);
__exportStar(require("./DealsApi"), exports);
__exportStar(require("./DraftsApi"), exports);
__exportStar(require("./EstimatesApi"), exports);
__exportStar(require("./ExperimentsApi"), exports);
__exportStar(require("./MeasurementDatasetsApi"), exports);
__exportStar(require("./MobileMeasurementApi"), exports);
__exportStar(require("./OffersApi"), exports);
__exportStar(require("./PixelMeasurementApi"), exports);
__exportStar(require("./PodcastShowsApi"), exports);
__exportStar(require("./PrepayApi"), exports);
__exportStar(require("./PricingApi"), exports);
__exportStar(require("./PromoCodesApi"), exports);
__exportStar(require("./ReportsApi"), exports);
__exportStar(require("./ReservationsApi"), exports);
__exportStar(require("./SalesforceApi"), exports);
__exportStar(require("./SurveysApi"), exports);
__exportStar(require("./TargetsApi"), exports);
__exportStar(require("./TestsApi"), exports);
__exportStar(require("./VatApi"), exports);
